import {
    AOV_LOADING,
    AOV_SUCCESS
} from '../actions/AOVAction';

const initialState = {

    amazon: {
        aovData: null,
        isLoading: true
    },
    shopify: {
        aovData: null,
        isLoading: true
    },
    wholesale: {
        aovData: null,
        isLoading: true
    },
};

const AOVReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case AOV_SUCCESS:
            return { ...state, [action.vendor]: { aovData: action.data, isLoading: false } };
        case AOV_LOADING:
            return { ...state, [action.vendor]: { ...state?.[action.vendor], isLoading: action.isLoading } };

        default:
            return state;
    }
};

export default AOVReducer;
